import React, { useCallback } from 'react'
import { SocialSharing } from '@/organisms/SocialSharing/SocialSharingSOFLargeButtonExperiment'
import { useSafeTrack } from '@/utils/analytics'

interface SharingBlockProps {
  projectSlug: string
  viewImpact?: () => void
  showImpact?: boolean
  shareUrl: string
}

export const SharingBlock: React.FC<SharingBlockProps> = ({ projectSlug, shareUrl }) => {
  const track = useSafeTrack()

  const trackShare = useCallback(
    (network: string) => {
      track('PIF Share Clicked', {
        type: network,
        projectSlug: projectSlug,
      })
    },
    [track, projectSlug],
  )

  return (
    <div className="flex flex-col gap-4 text-center">
      <div className="">
        <SocialSharing
          color="gray-950"
          onShare={trackShare}
          projectSlug={projectSlug}
          url={`https://www.angel.com${shareUrl}`}
        />
      </div>
    </div>
  )
}
